import { render, staticRenderFns } from "./news_view.vue?vue&type=template&id=189ff1e4&scoped=true&"
import script from "./news_view.vue?vue&type=script&lang=js&"
export * from "./news_view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189ff1e4",
  null
  
)

export default component.exports